// Type-safe Object.keys that preserves exact key types
export function strictKeys<V, T extends Record<string, V>>(obj: T): (keyof T)[] {
  return Object.keys(obj) as (keyof T)[];
}
// Type-safe Object.entries that preserves exact key and value types, even literals
export function strictEntries<V, T extends Record<PropertyKey, V>>(
  obj: T,
): { [K in keyof T]: [K, T[K]] }[keyof T][] {
  return Object.entries(obj) as { [K in keyof T]: [K, T[K]] }[keyof T][];
}

// Type-safe pick function that extracts specified keys from an object
export function pick<T, K extends keyof T>(obj: T, keys: readonly K[]): Pick<T, K> {
  return keys.reduce(
    (acc, key) => {
      acc[key] = obj[key];
      return acc;
    },
    {} as Pick<T, K>,
  );
}
